import { render, staticRenderFns } from "./DataView.vue?vue&type=template&id=646795e0&scoped=true"
import script from "./DataView.vue?vue&type=script&lang=js"
export * from "./DataView.vue?vue&type=script&lang=js"
import style0 from "./DataView.vue?vue&type=style&index=0&id=646795e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646795e0",
  null
  
)

export default component.exports